import React, { memo } from 'react';
import { CustomPicker } from 'react-color';
import { EditableInput, Hue, Saturation } from 'react-color/lib/components/common';

import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import { Input } from '../common-inputs';

import './ColorInput.scss';

const ColorPicker = ({ onChange, opacity, onChangeOpacity, disableAlpha, ...props }) => {
  const handleColorChange = (newColor) => {
    onChange(newColor);
  };

  const handleOpacityChange = (newValue) => {
    onChangeOpacity(newValue.trim());
  };

  return (
    <div className='color-picker_wrapper'>
      <div className='color-picker_saturation_wrapper'>
        <Saturation
          {...props}
          onChange={handleColorChange}
          pointer={() => (
            <Icon icon={ICONS.Donut} disableCommonStyles disableCommonColors className='color-picker_pointer_icon' />
          )}
        />
      </div>

      <div className='color-picker_bottom-section'>
        <div className='color-picker_hue_wrapper'>
          <Icon icon={ICONS.Dropper} className='color-picker_hue_icon' />
          <div className='color-picker_hue_track'>
            <Hue
              {...props}
              direction='horizontal'
              pointer={() => (
                <Icon
                  icon={ICONS.Donut}
                  disableCommonStyles
                  disableCommonColors
                  className='color-picker_pointer_icon'
                />
              )}
              onChange={handleColorChange}
              width='200px'
            />
          </div>
        </div>

        <div className='color-picker_input_wrapper'>
          <EditableInput value={props.hex} onChange={handleColorChange} style={editableInputStyles} />
          <Input
            size='sm'
            type='number'
            min={1}
            max={100}
            value={opacity}
            onChange={handleOpacityChange}
            maxWidth={70}
            isReadOnly={disableAlpha}
            extraInputClass='color-picker_input-percent_field'
            extraWrapperClass='color-picker_input-percent_wrapper'
            RightIcon={<span className='color-picker_input-percent_icon'>%</span>}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(CustomPicker(ColorPicker));

const editableInputStyles = {
  input: {
    width: '100%',
    borderRadius: '5px 0px 0px 5px',
    border: '1px solid var(--input-border)',
    color: 'var(--input-text)',
    backgroundColor: 'transparent',
    transition: 'border 0.2s ease',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '12px',
    padding: '10px 5px 10px 15px',
    borderRight: 'none',

    '&:hover': { border: '1px solid var(--input-border-hover)' },
    '&:focus': { border: '1px solid var(--input-border-focus)' },
    '&::placeholder': { color: 'var(--input-placeholder)', fontSize: '12px' },
  },
  wrapper: {
    width: '100%',
  },
};
